import Sticky from 'sticky-js';

import { Controller } from 'stimulus';

export default class extends Controller {

  connect() {
    new Sticky('.suppliers_header');
  }

  disconnect() {
    const sticky = new Sticky('.suppliers_header');
    sticky.destroy();
  }
}